import React from 'react';
import { NavLink, withRouter } from 'react-router-dom';
import { NavItem, NavDropdown, MenuItem } from 'react-bootstrap';
import { LinkContainer } from 'react-router-bootstrap';
import lang from '../../assets/lang';
import LogoBlack from '../../assets/images/logo.svg';
import LogoWhite from '../../assets/images/logo_white.svg'

const Header = (props) => {

	const headerStyle = props.location.pathname === '/' ? 'header-style-one' : 'header-style-two';
	const Logo = props.location.pathname === '/' ? LogoWhite : LogoBlack;

	return (
		<header className={`main-header header-style-one ${headerStyle}`}>
			<div className="main-box">
				<div className="auto-container">
					<div className="outer-container clearfix">
						<div className="logo-box">
							<div className="logo">
								<NavLink to="/"><img src={Logo} alt={Logo} /></NavLink>
							</div>
						</div>

						<div className="nav-outer clearfix">
							<div className="main-menu">
								<div className="navbar-header">
									<button
										type="button"
										className="navbar-toggle"
										data-toggle="collapse"
										data-target=".navbar-collapse">
										<span className="icon-bar" />
										<span className="icon-bar" />
										<span className="icon-bar" />
									</button>
								</div>

								<div className="navbar-collapse collapse clearfix">
									<ul className="navigation clearfix">
										<LinkContainer to="/" exact activeClassName="current">
											<NavItem>{lang.titleHome}</NavItem>
										</LinkContainer>

										<LinkContainer to="/about" exact activeClassName="current">
											<NavItem>{lang.titleAboutUs}</NavItem>
										</LinkContainer>

										<LinkContainer to="/services" exact activeClassName="current">
											<NavItem>{lang.titleServices}</NavItem>
										</LinkContainer>

										<LinkContainer to="/blog" exact activeClassName="current">
											<NavItem>{lang.titleBlog}</NavItem>
										</LinkContainer>

										<LinkContainer to="/contact" exact activeClassName="current">
											<NavItem>{lang.titleContact}</NavItem>
										</LinkContainer>

										<NavDropdown title={props.activeLanguage} id="swazerlab-drop-down">
											<MenuItem onClick={() => props.changeLanguage('EN')}>English</MenuItem>
											<MenuItem onClick={() => props.changeLanguage('TR')}>Türkçe</MenuItem>
										</NavDropdown>

									</ul>
								</div>
							</div>

						</div>

					</div>
				</div>
			</div>

		</header>
	);
};


export default withRouter(Header);



// WEBPACK FOOTER //
// ./src/components/layout/Header.js